module.exports = __webpack_public_path__ + "img/user-out.40b4eae0.svg";